__turbopack_context__.v({
  "infoContainer": "styles-module-scss-module__drKGlq__infoContainer",
  "infoIcon": "styles-module-scss-module__drKGlq__infoIcon",
  "infoTitle": "styles-module-scss-module__drKGlq__infoTitle",
  "infoWrapper": "styles-module-scss-module__drKGlq__infoWrapper",
});
